import React from "react";

React.lazy(() =>
    import(
        /* webpackMode: "eager" */
        "@omni/components/components/General/Sidebar/sidebar.default"
    ).then((module) => ({
        default: module.SidebarDefault
    }))
);
